import { HttpClient } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Observer } from 'rxjs';
import { sortTable } from 'src/app/helpers/sort-table';
import { ITestRequest, TestRequest } from 'src/app/_models/test-request.model';
import { TestRequestService } from 'src/app/_services/test-request.service';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import * as XLSX from 'xlsx';
import { MedicalTestRequestService } from 'src/app/_services/medical-test-request/medical-test-request.service';
import { UploadMultipleFilesModalComponent } from '@components/upload-multiple-files-modal/upload-multiple-files-modal.component';
import { showNotification } from 'src/app/helpers/show-toast';
import { IAttachmentsFilesDTO } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { DatePipe } from '@angular/common';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';

@Component({
  selector: 'app-test-requests-list',
  templateUrl: './test-requests-list.component.html',
  styleUrls: ['./test-requests-list.component.scss'],
})
export class TestRequestsListComponent implements OnInit {
  pageTitle: string = 'Test Requests';
  filteredTestRequests: ITestRequest[] = [];
  currentPage = 1;
  totalPages = 2;
  invertSort: boolean = false;
  base64Image: any;
  modalRef: BsModalRef;
  changedTestRequestId: number;
  pageId: number = 1;
  isPageChanged = false;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Oh !! There is no Requests',
    totalMessage: 'total',
    selectedMessage: ''
  }
  totalItems: number;
  pageSize: number = 10;
  @ViewChild('testListRef') public testListRef: TemplateRef<any>;
  @ViewChild('uploadRef') public uploadRef: TemplateRef<any>;
  @ViewChild('downloadRef') public downloadRef: TemplateRef<any>;


  wscols =[{wch:20},
    {wch:35},
    {wch:10},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
    {wch:20},
  ]

  constructor(
    private testRequestService: TestRequestService,
    public toastr: ToastrService,
    private medicalTestRequestService: MedicalTestRequestService,
    private modalService: BsModalService,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.handleGetTestRequestsByTypeId(this.pageId);
  }

  // ExportTOExcel(): void {
  //   let data :TestRequest[]=[];
  //   this.testRequestService.getExportExcel(this.pageId-1).subscribe(res=>{
  //     data  = res.data;
  //     const ws = XLSX.utils.json_to_sheet(data);
  //     /* generate workbook and add the worksheet */
  //     const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //     /* save to file */
  //     XLSX.writeFile(wb, `Test Requests - ${Date.now()}.xlsx`);
  //   })
 
  // }

exportExcel(name: string) {
  const fileName = `${name} - ${new Date().toISOString().slice(0, 10)}.xlsx`;

  // Fetch data asynchronously using the service
  this.testRequestService.getExportExcel(this.pageId - 1).subscribe(res => {
    let dataToExport = res.data;  // Assume res.data is the array of TestRequest objects

    // Define a mapping for column renaming
    const columnMapping = {
      patientName: 'Patient Name',
      patientAddress: 'Patient Address',
      patientPhone: 'Patient Phone',
      'center?.name': 'Center Name',
      branchAddress: 'Branch Address',
      isPersonal: 'Personal',
      isHomeVisit: 'Home Visit',
      tests: 'Tests',
      creationDate: 'Creation Date',
    };

    // Specify fields to exclude from the export
    const fieldsToExclude = ['id', 'Actions', 'Upload Result', 'files', 'testRequestType'];

    // Transform, rename, and apply Yes/No logic in `isPersonal` and `isHomeVisit`
    const transformedData = dataToExport.map(item => {
      const newItem = {};
      Object.keys(item).forEach(key => {
        if (!fieldsToExclude.includes(key)) {
          // Use columnMapping to rename the key, or default to the original key if no mapping exists
          const newKey = columnMapping[key] || key;
          
          // Apply Yes/No logic for `isPersonal` and `isHomeVisit`
          if (key === 'isPersonal' || key === 'isHomeVisit') {
            newItem[newKey] = item[key] ? 'Yes' : 'No';
          } 
          // Concatenate test names if `tests` is an array of test objects with a `name` property
          else if (key === 'tests' && Array.isArray(item.tests)) {
            // Join test names with newline characters
            newItem[newKey] = item.tests.map(test => test.name).join('\n -');
          }
          else {
            newItem[newKey] = item[key];
          }
        }
      });
      return newItem;
    });

    // Convert to worksheet format with renamed columns
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformedData);

    // Optionally set column widths if you have `wscols` defined
    ws['!cols'] = this.wscols;

    // Create a new workbook and add the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Write to file
    XLSX.writeFile(wb, fileName);
  });
}

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredTestRequests = sortTable(
      this.filteredTestRequests,
      'creationDate',
      this.invertSort
    );
  }

  getBase64ImageFromURL(url: string) {
    return Observable.create((observer: Observer<string>) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      if (!img.complete) {
        img.onload = () => {
          observer.next(this.getBase64Image(img));
          observer.complete();
        };
        img.onerror = (err) => {
          observer.error(err);
        };
      } else {
        observer.next(this.getBase64Image(img));
        observer.complete();
      }
    });
  }

  getBase64Image(img: HTMLImageElement) {
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx: CanvasRenderingContext2D = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    const dataURL: string = canvas.toDataURL('image/png');

    return dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
  }

  onUploadTestResult(testRequest:ITestRequest) {
    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
      initialState: {
        title: "Test Request Files",
        subtitle: `Please upload test request results below by dragging the file or clicking upload files.`,
        filesExisted: testRequest.files?.map(f => {return {id: f.id, path: f.path, isEditable: false}})
      },
    };

    this.modalRef = this.modalService.show(
      UploadMultipleFilesModalComponent,
      initialState
    );

    this.modalRef.content.event.subscribe((response) => {
      if(response.action === 'uploadFiles'){
        this.testRequestService.uploadTestRequestResult(testRequest.id, response.filesToUpload)
        .subscribe((response) => {
          if (response?.data) {
            this.filteredTestRequests.find(t => t.id == testRequest.id).files = response.data.attachmentUrls as [{id:number, path:string}];
            showNotification(
              'success',
              'The result has been uploaded successfully.',
              this.toastr
            );
          }
          else {
            showNotification(
              'danger',
              `${response?.errorList[0]?.message}`,
              this.toastr
            )
          }
        });

        this.modalRef.hide();
      }
    });
  }

  changePageId(pageId: number){
    this.pageId = pageId;
    this.isPageChanged = true;
    this.handleGetTestRequestsByTypeId(pageId);
  }

  downloadFile(fileUrl) {
    this.medicalTestRequestService
      .downloadFile(fileUrl)
      .subscribe((response) => {
        let fileName = fileUrl.split('/').pop();
        let a = document.createElement('a');
        let objectUrl = URL.createObjectURL(response);
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
  }

  downloadTestRequestResults(testRequest:ITestRequest) {
    testRequest.files.forEach((f => this.downloadFile(f.path)));
  }

  handleGetTestRequestsByTypeId(typeId: number){
    if(this.isPageChanged){
      this.currentPage = 1;
      this.isPageChanged = false;
    }

    this.testRequestService.getTestRequestsByType(this.currentPage, this.pageSize, typeId-1)
    .subscribe((res) => {
      this.totalPages = res?.data?.pagination?.totalPages;
      this.totalItems = res?.data?.pagination?.totalItems;

      this.initilaizeColumns();

      this.filteredTestRequests = res?.data?.items;
    });
  }

  initilaizeColumns() {
    setTimeout(() => {
      this.columns = [
        {prop: 'patientName', name: 'Patient Name'},
        {prop: 'patientAddress', name: 'Patient Address'},
        {prop: 'patientPhone', name: 'Patient Phone'},
        {prop: 'center.name', name: 'Center Name'},
        {prop: 'branchAddress', name: 'Branch Address'},
        {prop: 'isPersonal', name: 'Personal', pipe: {transform: (val) => val ? '🟢 YES' : '🔴 NO'}},
        {prop: 'isHomeVisit', name: 'Home Visit', pipe: {transform: (val) => val ? "🏠 Home" : "🏥 Lab"}},
        {prop: 'item.tests', name: 'Tests', cellTemplate: this.testListRef, width: 200},
        {prop: 'creationDate', name: 'Creation Date', width: 200,
          pipe: {transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a")}},
        {prop: '', name: 'Upload Result', sortable: false, cellTemplate: this.uploadRef, width: 200},
        {prop: '', name: 'Result', sortable: false, cellTemplate: this.downloadRef, width: 200},
      ]
    }, 0)

  }

  onChangePage(pageDetails: ISmartTablePagination){
    this.currentPage = pageDetails.offset + 1;
    this.handleGetTestRequestsByTypeId(this.pageId);
  }
}
